<div *ngIf="menuCtrl" class="menu-template-container" [ngStyle]="menuContainerStyle">
   <ng-container *ngTemplateOutlet="menuTemplate; context: menuCtrl.context"></ng-container>
</div>